export default "__VITE_ASSET__e5110e9b__"